<ng-template><div class="ui-menu-container {{customClass}}"><ng-content></ng-content></div></ng-template>